import React from 'react';

import { connect } from 'react-redux';

import EsmsCard from '../../components/EsmsCard';

import classes from './AccountInformationCard.module.css';

const AccountInformationCard = ({ currentUser: { userName, email, phone }}) =>
    (
        <EsmsCard
            title="Account Information"
            imagePath="/assets/images/blankProfileFlat.svg"
        >
            <div className={classes.accountInfo}>
                <p>
                    <span>Name</span>
                    {userName}
                </p>
                <p>
                    <span>Email</span>
                    {email}
                </p>
                <p>
                    <span>Phone</span>
                    {phone}
                </p>
            </div>
        </EsmsCard>
    );


const mapStateToProps = state => {
    return {
        currentUser: state.currentUser
    };
};

export default connect(mapStateToProps)(AccountInformationCard);
